import _ from 'lodash';
import React, {FunctionComponent, useEffect, useState} from 'react';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@material-ui/icons';
import {ImageAttributes} from '@treez/commons/sharedTypings';
import Checkbox from '@treez-ui/core/forms/Checkbox';
import {AddIcon, DeleteIcon} from '@treez-ui/core/icons';
import {Button, ButtonClass} from '@treez-ui/core/buttons';
import {TreezColor, treezColorMap} from '~/styles/constants';

interface Props {
    images: ImageAttributes[];
    onSelectAll?: (checked: boolean) => void;
    onSelectImage?: (image: ImageAttributes) => void;
    selectedImages?: ImageAttributes[];
}

enum GalleryDirections {
    BACK = 'back',
    FORWARD = 'forward',
}

const {BACK, FORWARD} = GalleryDirections;

export const PhotoGallery: FunctionComponent<Props> = (props: Props) => {
    const {images, onSelectAll, onSelectImage, selectedImages = []} = props;

    const [galleryOrder, setGalleryOrder] = useState<ImageAttributes[]>();

    useEffect(() => {
        const defaultOrder = _.orderBy(images, ['default'], ['desc']);
        setGalleryOrder(defaultOrder);
    }, [images]);

    const handleGalleryBrowsing = (direction: GalleryDirections) => {
        if (galleryOrder) {
            let newOrder;
            if (direction === BACK) {
                newOrder = galleryOrder.slice(0, galleryOrder.length - 1);
                newOrder.unshift(galleryOrder[galleryOrder.length - 1]);
            } else if (direction === FORWARD) {
                newOrder = galleryOrder.slice(1, galleryOrder.length);
                newOrder.push(galleryOrder[0]);
            }
            setGalleryOrder(newOrder);
        }
    };

    const allImagesSelected =
        _.size(images) > 0 &&
        _.every(images, (img) => {
            const selectedImageUrls = _.map(selectedImages, 'url');
            return _.includes(selectedImageUrls, img.url);
        });

    return (
        <div className="photo-gallery-container">
            {galleryOrder && galleryOrder.length > 0 && (
                <div className="photo-gallery">
                    {onSelectImage && (
                        <div className="photo-gallery-select-container">
                            {onSelectAll && (
                                <div>
                                    {!allImagesSelected && (
                                        <Button
                                            buttonClass={ButtonClass.PREFERRED}
                                            icon={<AddIcon color="white" />}
                                            onClick={() => onSelectAll(true)}
                                            text="Select All"
                                        />
                                    )}
                                    {allImagesSelected && (
                                        <Button
                                            buttonClass={ButtonClass.QUIET}
                                            icon={
                                                <DeleteIcon
                                                    color={treezColorMap[TreezColor.ERROR_RED]}
                                                />
                                            }
                                            onClick={() => onSelectAll(false)}
                                            text="Remove All"
                                        />
                                    )}
                                </div>
                            )}
                            <div className="select-image-container">
                                Select Image
                                <Checkbox
                                    // remove label with new core-ui
                                    label=""
                                    onClick={() => onSelectImage(galleryOrder[0])}
                                    checked={_.includes(
                                        _.map(selectedImages, 'url'),
                                        galleryOrder[0].url
                                    )}
                                />
                            </div>
                        </div>
                    )}
                    <div className="main-image">
                        <img src={galleryOrder[0].url} />
                    </div>
                    <div className="gallery-preview-container">
                        {galleryOrder[1] && (
                            <KeyboardArrowLeft
                                fontSize="large"
                                onClick={() => handleGalleryBrowsing(BACK)}
                            />
                        )}

                        {galleryOrder[1] && <img src={galleryOrder[1].url} />}
                        {galleryOrder[2] && <img src={galleryOrder[2].url} />}
                        {galleryOrder[3] && <img src={galleryOrder[3].url} />}

                        {galleryOrder[1] && (
                            <KeyboardArrowRight
                                fontSize="large"
                                onClick={() => handleGalleryBrowsing(FORWARD)}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PhotoGallery;
